import * as z from "zod/v4";

export const deleteLocation = {
  name: "deleteLocation" as const,
  input: z.object({ locationId: z.string() }),
  output: z.null(),
};
